import React, { useMemo } from 'react';
import { Menu, MenuButton, Icon, MenuList, MenuItem, MenuDivider, Button } from '@chakra-ui/react';
import { ChevronDown } from 'react-feather';
import { ECustomThemeViews } from '@olo-web/types/enums';
import { auth } from '@olo-web/utils/google/firebase';
import { useCustomThemeDraftDispatch, useCustomThemeDraftState } from '@olo-web/client-state';
import { Label, label } from '../constants';
import { useThemeRoles } from '@olo-web/domain/firebaseAuth';
import { useFeatureFlags } from '@olo-web/domain';

export const ThemeMenu = () => {
  const themeDispatch = useCustomThemeDraftDispatch();
  const { view } = useCustomThemeDraftState();
  const { isAdmin, isOwner } = useThemeRoles();
  const { data: flags } = useFeatureFlags();

  const handleLogout = () => {
    auth().signOut();
  };

  const handleSetView = (key: ECustomThemeViews) => {
    themeDispatch({
      type: 'SET_VIEW',
      payload: key,
    });
  };

  // TODO: We should convert this to use omit instead of `delete` as it would be simpler and easier to read
  const filteredLabels = useMemo(() => {
    const l: Label = { ...label };
    if (flags?.hideMerchantThemeFonts) {
      delete l[ECustomThemeViews.FONTS];
    }
    return l;
  }, [flags?.hideMerchantThemeFonts]);

  return (
    <Menu>
      <MenuButton
        as={Button}
        size="lg"
        variant="ghost"
        colorScheme="blackAplha"
        rightIcon={<Icon as={ChevronDown} h={6} w={6} />}
        alignSelf="flex-start"
        textDecor="underline"
        px={view && (label?.[view] ? 2 : 0)}
        _hover={{
          color: 'primary.350',
        }}
      >
        {view ? label[view] ?? view : null}
      </MenuButton>
      <MenuList>
        {Object.keys(filteredLabels).map((key) => (
          <MenuItem key={key} onClick={() => handleSetView(key as ECustomThemeViews)}>
            {label[key]}
          </MenuItem>
        ))}
        <MenuDivider />
        {(isAdmin || isOwner) && (
          <>
            <MenuItem onClick={() => handleSetView(ECustomThemeViews.PIXELS_AND_KEYS)}>
              pixels and keys
            </MenuItem>
            <MenuItem onClick={() => handleSetView(ECustomThemeViews.MANAGE_LOCATIONS)}>
              manage locations
            </MenuItem>
            <MenuItem onClick={() => handleSetView(ECustomThemeViews.MANAGE_ACCESS)}>
              manage access
            </MenuItem>
            <MenuItem onClick={() => handleSetView(ECustomThemeViews.SETTINGS)}>settings</MenuItem>
          </>
        )}
        {isAdmin && (
          <MenuItem onClick={() => handleSetView(ECustomThemeViews.ADMIN)}>admin</MenuItem>
        )}
        <MenuItem onClick={handleLogout} color="danger.300">
          logout
        </MenuItem>
      </MenuList>
    </Menu>
  );
};
